import Logo from '@/assets/images/LOGO.png';
import { Button } from '@/components/ui/button';
import { IoClose } from 'react-icons/io5';
import { Outlet, useNavigate } from 'react-router-dom';

const TransferLayout = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/virtual-account');
    };

    return (
        <div className="min-h-screen bg-[linear-gradient(135deg,_#f8f9fa_0%,_#f0f1f3_100%)] dark:bg-[linear-gradient(135deg,_#000000_0%,_#000000_100%)]">
            <div className="border-b-[0.1rem] dark:bg-[#000000] bg-[#FFFFFF] border-[#717171] flex justify-between items-center lg:px-[3.4rem] px-[1.5rem] lg:py-[2.4rem] py-[1.5rem] h-[4.5rem] lg:h-[6rem]">
                <img className="h-full" src={Logo} alt="Logo-NezenX" />
                <Button
                    type="button"
                    onClick={handleClose}
                    className="text-[#57E8BA] hover:text-[#4dd4a7] p-0 transition-colors bg-transparent hover:bg-transparent"
                >
                    <IoClose className="size-10" />
                </Button>
            </div>
            <Outlet />
        </div>
    );
};

export default TransferLayout;

